import _construct from "@babel/runtime/helpers/construct";
import { observable } from 'mobx';
import { classDecorator } from 'decorating';
import difference from 'lodash.difference';
import intersection from 'lodash.intersection';
export default classDecorator(function (target) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      only = _ref.only,
      except = _ref.except;

  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var store = _construct(target, args);

    var props = Object.keys(store);

    if (only) {
      props = intersection(props, only);
    }

    props = difference(props, except);
    props.forEach(function (prop) {
      var desc = Object.getOwnPropertyDescriptor(store, prop);
      desc = observable(store, prop, desc);
      Object.defineProperty(store, prop, desc);
    });
    return store;
  };
});